/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../../../app/bsky/actor/defs.defs.js'

const $nsid = 'tools.ozone.team.defs'

export { $nsid }

type Member = {
  $type?: 'tools.ozone.team.defs#member'
  did: l.DidString
  disabled?: boolean
  profile?: ActorDefs.ProfileViewDetailed
  createdAt?: l.DatetimeString
  updatedAt?: l.DatetimeString
  lastUpdatedBy?: string
  role:
    | 'tools.ozone.team.defs#roleAdmin'
    | 'tools.ozone.team.defs#roleModerator'
    | 'tools.ozone.team.defs#roleTriage'
    | 'tools.ozone.team.defs#roleVerifier'
    | l.UnknownString
}

export type { Member }

const member = /*#__PURE__*/ l.typedObject<Member>(
  $nsid,
  'member',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    disabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    profile: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewDetailed>(
        (() => ActorDefs.profileViewDetailed) as any,
      ),
    ),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastUpdatedBy: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    role: /*#__PURE__*/ l.string<{
      knownValues: [
        'tools.ozone.team.defs#roleAdmin',
        'tools.ozone.team.defs#roleModerator',
        'tools.ozone.team.defs#roleTriage',
        'tools.ozone.team.defs#roleVerifier',
      ]
    }>(),
  }),
)

export { member }

/** Admin role. Highest level of access, can perform all actions. */
type RoleAdmin = 'tools.ozone.team.defs#roleAdmin'

export type { RoleAdmin }

/** Admin role. Highest level of access, can perform all actions. */
const roleAdmin = /*#__PURE__*/ l.token($nsid, 'roleAdmin')

export { roleAdmin }

/** Moderator role. Can perform most actions. */
type RoleModerator = 'tools.ozone.team.defs#roleModerator'

export type { RoleModerator }

/** Moderator role. Can perform most actions. */
const roleModerator = /*#__PURE__*/ l.token($nsid, 'roleModerator')

export { roleModerator }

/** Triage role. Mostly intended for monitoring and escalating issues. */
type RoleTriage = 'tools.ozone.team.defs#roleTriage'

export type { RoleTriage }

/** Triage role. Mostly intended for monitoring and escalating issues. */
const roleTriage = /*#__PURE__*/ l.token($nsid, 'roleTriage')

export { roleTriage }

/** Verifier role. Only allowed to issue verifications. */
type RoleVerifier = 'tools.ozone.team.defs#roleVerifier'

export type { RoleVerifier }

/** Verifier role. Only allowed to issue verifications. */
const roleVerifier = /*#__PURE__*/ l.token($nsid, 'roleVerifier')

export { roleVerifier }
